import { useIDEState } from '@/hooks/use-ide-state';
import { pageTitle } from '@/utils/page-metadata';
import React, { useEffect } from 'react';
import { FileViewer } from './file-viewer';
import { TabBar } from './tab-bar';

interface EditorPanelProps {
    id?: string;
    className?: string;
}

export const EditorPanel: React.FC<EditorPanelProps> = ({ id, className = 'flex-1 flex flex-col overflow-hidden' }) => {
    const { state } = useIDEState();
    useEffect(() => {
        const tab = state.tabs.find(tab => tab.id === state.activeTabId);
        const project = state.projects.find(project => project.id === tab?.projectId);
        document.title =
            tab && project
                ? pageTitle(`/${project.name}/${tab.title}`, `${project.name}: ${tab.title}`)
                : 'Portfolio — Faris Rehman';
    }, [state.activeTabId, state.tabs, state.projects]);

    return (
        <div id={id} className={className}>
            {/* Tab Bar */}
            <TabBar />

            {/* Content Area */}
            <div
                id='ide-editor-content'
                role={state.activeTabId ? 'tabpanel' : undefined}
                aria-labelledby={state.activeTabId ? `tab-label-${state.activeTabId}` : undefined}
                className='flex-1 overflow-hidden'
            >
                <FileViewer key={state.activeTabId || 'no-tab'} />
            </div>
        </div>
    );
};
